/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { marketSectionDtoSchema } from "./marketSectionDtoSchema.ts";
import { pitchDeckRejectionDtoSchema } from "./pitchDeckRejectionDtoSchema.ts";
import { z } from "zod/v4";

export const sectionMarketSectionDtoSchema = z.object({
  status: z.optional(
    z
      .enum(["Pending", "Running", "Completed", "Failed", "NotImplemented"])
      .default("Pending"),
  ),
  jobId: z.string().nullish(),
  startedAt: z.iso.datetime().nullish(),
  updatedAt: z.iso.datetime().nullish(),
  get rejection() {
    return pitchDeckRejectionDtoSchema.nullish();
  },
  get data() {
    return marketSectionDtoSchema.nullish();
  },
});
